import { AppService } from "app/services/app.service";

import { ConfigSeguranca } from "app/models/configseguranca.model";
import { Observable } from "rxjs";

export abstract class AbConfigSeguranca extends AppService {
  abstract getConfigSeguranca(): Observable<any>;
  abstract saveConfigSeguranca(configSeguranca: ConfigSeguranca): Observable<any>;
} 